export default __webpack_public_path__ + "static/media/take_control_heading_en.a6e055ef.svg";